import script from "./digitalMan.vue?vue&type=script&lang=ts&setup=true"
export * from "./digitalMan.vue?vue&type=script&lang=ts&setup=true"

import "./digitalMan.vue?vue&type=style&index=0&id=7a11062d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a11062d"]])

export default __exports__